import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleAreaMultiple extends TitleBase {
	protected canHandle(): boolean {
		return (
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.multiValueFilters.some((_) => _.type === ParameterType.AREA)
		);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in selected regions`;
	}
}
